export default "__VITE_ASSET__KKeNefr8__"